import { FilterV2Identifier } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { getFilterGroupAndName } from "PFCore/helpers/filters";
import { FiltersV2, FilterV2 } from "PFTypes/filters_v2";
import { RequireAtLeastOne } from "type-fest";

export const getFilterName = ({
  originalPath,
  name
}: RequireAtLeastOne<Pick<FilterV2, "originalPath" | "name">, "originalPath" | "name">) =>
  name || getFilterGroupAndName(originalPath!).name;

export const getFilterByIdentifier = (
  filters: FiltersV2,
  identifier: FilterV2Identifier
): FilterV2 | undefined => getFilterName(identifier) && filters[getFilterName(identifier)];
